import type { PatientConsentQuestion } from '@/hooks/patient/useGetPatientConsentQuestions';
import { Box, Typography } from '@montugroup/design-system';

interface PatientConsentQuestionsProps {
  questions: PatientConsentQuestion[] | null;
}

export const PatientConsentQuestions = (props: PatientConsentQuestionsProps) => {
  const { questions } = props;

  return (
    <Box>
      {questions?.map((question) => (
        <Box key={question.id} mb={3}>
          <Typography variant="h6">{question.category}</Typography>
          <Typography>{question.description}</Typography>
        </Box>
      ))}
    </Box>
  );
};
